<template lang="pug">

    //- THIS IS A DRAFT JADE CODE
    //- TODO: Change to fulfill component view and functionality

    .next-block(:class="typeClass")

        .next-block__title
            .next-block__title__wrap
                h3.h3
                    span(v-if='decorationType === "small"', v-html="'&lt;/div>--><br /></'")
                    span(v-if='decorationType === "middle"', v-html="'</'")
                    span(v-if='decorationType === "normal"', v-html="'&lt;?/<br />'")
                    span(v-html='realTitle')
                    span(v-if='decorationType === "small" || decorationType === "middle"', v-html="':/><br />&lt;/b>'")

        .next-block__wrap
            //(ref='cta')
            router-link.next-block__cta(tag="button", :class="{disabled: nextDisabled}", :disabled="!active || nextDisabled", :to="sectionData.url || sectionData.id", @click.native="trackNav()"): span(v-html="realCTA")



</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'next-block',

    props: {
        content: {
            default: () => {
                return {};
            },
            type: Object
        },
        active: {
            default: false,
            type: Boolean
        }
    },

    computed: {
        ...mapGetters('nav', ['next', 'nextDisabled']),

        title() {
            if (!this.content) return '';
            return this.content.title || '';
        },

        realTitle() {
            if (!this.title || !this.sectionData) return '';
            return `${this.title} ${this.sectionData.title}`;
        },

        realCTA() {
            if (!this.content || !this.content.cta) return '>>';
            return this.nextDisabled ? this.content.cta.disabled : this.content.cta.active;
        },

        sectionData() {
            return this.next || {};
        },

        typeClass() {
            if (!this.content) return '';
            const types = this.content.types;
            if (!types || !(types instanceof Array)) return '';
            const pre = 'next-block--';
            return pre + types.join(pre);
        },

        decorationType() {
            if (!this.content) return '';
            return this.content.types[0] || '';
        }
    },

    methods: {
        trackNav() {
            if (this.$analytics !== undefined) {
                this.$analytics.sendEvent({
                    event: 'eventTracking',
                    category: `Navigation`,
                    action: 'click',
                    label: this.realTitle
                });
            }
        }
    }
};
</script>

<style lang="scss">
//
@import '../assets/css/vars';
@import 'swiper/dist/css/swiper.css';
//
.next-block {
    position: relative;
    display: flex;
    width: 100%;
    padding: 4.5em var(--width-column-grid) 7em;
    box-sizing: border-box;
    background-color: var(--color-outline-bg);
    margin-bottom: var(--width-column-grid);

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        padding: 3em var(--scr-padding-side) 0;
        margin-bottom: 2rem;
        flex-direction: column;
    }

    &__title {
        width: 50%;
        padding-right: 10%;
        font-size: 1.714em;
        color: var(--color-accent);

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            width: 100%;
            font-size: 1.2em;
            margin-bottom: 1em;
        }
    }

    &__wrap {
        width: 50%;
        position: relative;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            width: 100%;
        }
    }

    &__cta {
        position: relative;
        top: 5.1em;
        flex-shrink: 0;
        font-size: 1.75em;
        color: var(--color-text-over-accent);
        text-transform: uppercase;
        display: block;
        padding: 0.6em 1em;
        background-color: var(--color-accent-strong);
        animation: accent-strong-bg-blink-short 0.2s linear infinite both;

        &::before,
        &::after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            top: random(100) / 100 * 100%;
            bottom: random(100) / 100 * 100%;
            transform-origin: 0 0;
            animation: noise-anim 2s infinite linear alternate-reverse;
        }

        &:after {
            background: var(--color-accent);
            opacity: 0.7;
            z-index: 0;
        }

        &:before {
            background: #da9b1b;
            opacity: 0.5;
            z-index: 0;
            animation-duration: 5s;
        }

        &.disabled {
            &::before,
            &::after {
                display: none;
            }

            background: transparent;
            color: var(--color-accent-strong);
            border: 1px solid currentColor;
            animation: none;
        }

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            font-size: 1.48em;
            margin-bottom: 2.5em;
        }

        span {
            display: inline-block;

            &::before {
                content: '>>';
            }
        }
    }

    &__content {
        position: absolute;
        top: 0;
        left: 3.6em;
        color: var(--color-text-over-accent);
        width: 88%;
        height: 29.4em;
        flex-grow: 1;
        background-color: var(--color-accent-strong);
        padding: 3em 1em 1em 2em;
        opacity: 0;
        pointer-events: none;
        z-index: 2;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            position: absolute;
            top: auto;
            left: 0;
            width: 100%;
            height: 70vh;
            padding: 2em 0.7em;
        }

        @supports (--css: variables) {
            @media (--viewport-mobile), (--viewport-tablet-pt) {
                min-height: calc(var(--vh) * 70);
            }
        }

        .swiper-container {
            height: 100%;
        }

        .swiper-wrapper {
            height: auto;
            padding-right: 3em;
            box-sizing: border-box;
        }

        .swiper-scrollbar {
            width: 1em;
            border-radius: 0;
            background-color: transparent;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                width: 0.735em;
            }
        }

        .swiper-scrollbar-drag {
            border-radius: 0;
            background-color: var(--color-text-over-accent);
        }

        &.active {
            opacity: 1;
            pointer-events: all;
        }
    }
}

.modal-block {
    &__wrap {
        padding-bottom: 2em;
    }

    &__close {
        position: absolute;
        top: 1em;
        right: 1em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            top: 0.4em;
            right: 0.55em;
        }

        & button {
            position: relative;
            width: 1.5em;
            height: 1.5em;
            line-height: 1;
            padding: 0 0.05em;

            span {
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: 2px;
                display: block;
                background-color: var(--color-text-over-accent);
                transform-origin: center;
                transform: rotate(-45deg);

                &:last-child {
                    transform: rotate(45deg);
                }
            }
        }
    }

    &__text {
        p {
            margin-bottom: 1em;
        }
    }
}
</style>
